// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"61":"Money","111":"DemoItem"}[chunkId] || chunkId) + "." + {"61":"28370ff7","111":"f45a8f71","659":"80229c0b"}[chunkId] + ".css";
};